import {
   ChangeDetectorRef,
   Component,
   ElementRef,
   Input,
   OnChanges,
   OnInit,
   SimpleChanges,
   ViewContainerRef,
} from '@angular/core';
import { DeviceOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: BaseStationGroupSelectComponent,
        },
    ],
    selector: 'ndt-basestation-chip-select',
    templateUrl: './basestation-select.component.html',
    standalone: false
})
export class BaseStationGroupSelectComponent extends LcsSingleSelectBase<DeviceOption> implements OnInit, OnChanges {
   @Input() extensionIdsToExclude: number[] = [];

   @Input() extensions: DeviceOption[] = [];

   filteredOptions: DeviceOption[] = [];

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.updateFilteredOptions();
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (
         changes.extensionGroups ||
         changes.extensions ||
         changes.extensionGroupIdsToExclude ||
         changes.extensionIdsToExclude
      ) {
         this.updateFilteredOptions();
      }
   }

   updateFilteredOptions(): void {
      const filteredExtensions = this.extensions.filter(
         (ext) => !Array.isArray(this.extensionIdsToExclude) || !this.extensionIdsToExclude.includes(ext.phoneId)
      );

      this.filteredOptions = [...filteredExtensions];
   }

   displayWith(item: DeviceOption | null): string | null {
      if (!item) return null;
      return item.extension.name ? `${item.extension.number} - ${item.extension.name} (${item.handsetIpei})` : null;
   }

   trackBy = (item: DeviceOption | null): any => {
      if (item === null || typeof item !== 'object') {
         return null;
      }
      return item.phoneId;
   };
}
